export default {"src":"/_next/static/media/hight.a9afc1b9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};